<template>
  <div>
    <b-row>
      <b-col sm="12">
        <div class="component-margin-half">
          <invoice-common-filter
            :freeWordFilter="freeWordFilter"
            :recordCount = "recordCount"
            @changeFreeWordFilter="changeFreeWordFilter($event)"
            @registerNewRecord="dispRegisterMasterModal()"
            @outputCsv="outputCsv()"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="filteredItems" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="messageUpFlag" slot-scope="row">
            <b-checkbox size="sm" v-model="row.value" disabled></b-checkbox>
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" variant="warning">更新</b-button>
          </template>
          <template slot="delete" slot-scope="row">
            <b-button size="sm" @click="deleteRowConfirm(row)" variant="secondary">削除</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-pagination :total-rows="recordCount" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row>
    <b-modal ref="editModal" title="マッピング情報登録・更新" @ok="handleOk">
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="サブカテゴリ(from Amazon)" label-for="amazonSubCategory">
        <b-form-input size="sm" id="amazonSubCategory" v-model="editItem.amazonSubCategory" :disabled="isUpdate" type="text"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="インボイスカテゴリ" label-for="categoryName">
        <category-search :categoryName="editItem.categoryName" @selectedCategory="($event) => editItem.categoryId=$event" @selectedCategoryName="($event) => editItem.categoryName=$event" />
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="メッセージ表示要否" label-for="messageUpFlag">
        <b-checkbox size="sm" class="check-mark" v-model="editItem.messageUpFlag"></b-checkbox>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="表示メッセージ" label-for="message">
        <b-form-input size="sm" id="message" v-model="editItem.message" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="messagePopup" ok-only hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import InvoiceCommonFilter from '@/components/invoice/InvoiceCommonFilter';
import SearchCategory from '@/components/invoice/SearchCategory';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    },
    version: {
      default: 1,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'amazonSubCategory', label: 'サブカテゴリ(from Amazon)', sortable: true, variant: 'base', class: 'table-lw30' },
        { key: 'categoryName', label: 'インボイスカテゴリ', sortable: true, variant: 'warning', class: 'table-lw30' },
        { key: 'messageUpFlag', label: '紐付け不可', sortable: true, variant: 'warning', class: 'table-cw11' },
        { key: 'message', label: '表示メッセージ(紐付け不可選択時)', sortable: true, variant: 'warning' },
        { key: 'update', label: '更新', sortable: true, variant: 'success', class: 'table-cw5' },
        { key: 'delete', label: '削除', sortable: true, variant: 'success', class: 'table-cw5' },
      ],
      currentPage: 1,
      perPage: 100,
      sortBy: 'date',
      sortDesc: true,
      sortDirection: 'desc',
      freeWordFilter: '',
      editItem: {},
      confirmMessage: '',
      isUpdate: false,
      recordCount: 0
    };
  },
  created() {
    this.callApi();
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        return (this.freeWordFilter === '' || (item.categoryName !== null && item.categoryName.toUpperCase().indexOf(this.freeWordFilter.toUpperCase()) !== -1) ||
                (item.amazonSubCategory !== null && item.amazonSubCategory.toUpperCase().indexOf(this.freeWordFilter.toUpperCase()) !== -1));
      });
      this.recordCount = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
  },
  methods: {
    changeFreeWordFilter($event){
      this.freeWordFilter = $event;
    },
    callApi() {
      api.getMappingCategory((data) => {
        this.items = data.mappingCategoryList;
        this.recordCount = this.items.length;
      });
    },
    dispRegisterMasterModal(){
      this.isUpdate = false;
      this.editItem = {};
      this.$refs.editModal.show();
    },
    editModal(row) {
      this.editItem = {};
      // 更新処理の場合に情報をセット
      if (row !== null) {
        this.isUpdate = true;
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    handleOk() {
      if (this.isUpdate) {
      api.updateMappingCategory(this.editItem, (data) => {
        this.items = data.mappingCategoryList;
        this.recordCount = this.items.length;
        this.confirmMessage = '更新しました。';
        this.$refs.messagePopup.show();
        });
      } else{
      api.registerMappingCategory(this.editItem, (data) => {
        this.items = data.mappingCategoryList;
        this.recordCount = this.items.length;
        this.confirmMessage = '新規登録しました。';
        this.$refs.messagePopup.show();
        });
      }
    },
    deleteRowConfirm(row) {
      this.editItem = {};
      this.editItem =  Object.assign({}, this.editItem , row.item);
      this.confirmMessage = '削除しますか？';
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
      api.deleteMappingCategory(this.editItem, (data) => {
        this.items = data.mappingCategoryList;
        this.confirmMessage = '削除完了しました。';
        this.$refs.messagePopup.show();
      });
    },
    outputCsv() {
      let csv = '\ufeff' + 'サブカテゴリ(from Amazon),インボイスカテゴリ,メッセージ表示要否,表示メッセージ\n';
      let ids = [ 'amazonSubCategory', 'categoryName', 'messageUpFlag', 'message' ];
      let fileName = 'インボイス情報(カテゴリ).csv';
      for (const item of this.items) {
        csv = csv + '"';
        for (const id of ids) {
          csv += item[id] + '","';
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};

Vue.component('category-search', SearchCategory);
Vue.component('invoice-common-filter', InvoiceCommonFilter);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}
th.table-base {
  background-color: aliceblue!important;
}
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}
@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-lw30 { min-width: 30rem; max-width: 30rem; width: 30rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
